import React, {
  useState, ReactElement, useRef,
} from 'react';
import {
  Tag, Menu, Spin, Empty, Button, Tooltip
} from 'antd';

import { isMobile } from 'react-device-detect';
import { injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import ModalAdvise from '../../components/modalAdvise/modalAdvise';
import Encargo from './encargo';
import Optometria from './optometria';
import Aviso from './aviso';
import Contactologia from './contactologia';
import Presupuesto from './presupuesto';
import Audio from './audio';
import { Flex } from '../../../shared/components';
import { generatePath, useHistory } from 'react-router-dom';
import { ROUTE_PACIENTES_FILE } from '../../../../routes.constants';

const { CheckableTag } = Tag;

function Activity({ intl, pacientesWorkspace }:any) {
  const history = useHistory();
  const { pacienteSelected, activity } = pacientesWorkspace;
  const deviceMobile = isMobile;
  const dispatch = useDispatch();
  const [filters, setFilters] = useState(['encargos', 'presupuestos',
    'optometrias', 'contactologias', 'audio', 'avisos']);
  const [modalAdvise, setModalAdvise] = useState(false);
  const [adviseType, setAdviseType] = useState('');
  const [limit, setLimit] = useState(5);
  const sagas = useSelector((state: any) => state.sagas);
  const loadingActivity = sagas.GET_ACTIVITY_DATA?.running;
  const successActivity = sagas.GET_ACTIVITY_DATA?.success;
  // const chartContainer = useRef(null);
  const toggleFilter = (filter: string) => {
    const filtersCopy = [...filters];
    if (filtersCopy.includes(filter) && filters.length > 1) {
      const index = filtersCopy.indexOf(filter);
      if (index > -1) {
        filtersCopy.splice(index, 1);
        setFilters(filtersCopy);
      }
    } else {
      filtersCopy.push(filter);
      setFilters(filtersCopy);
    }
  };

  function closeModal() {
    setModalAdvise(false);
  }

  const menuAdvise = (
    <Menu>
      <Menu.Item key="1" onClick={() => { setModalAdvise(true); setAdviseType('sms'); }}>SMS</Menu.Item>
      <Menu.Item key="2" onClick={() => { setModalAdvise(true); setAdviseType('email'); }}>Email</Menu.Item>
    </Menu>
  );

  const activityComponents = activity.filter((e:any) => {
    if (e.tipoElemento === 'encargo' && filters.includes('encargos')) {
      return true;
    } if (e.tipoElemento === 'optometria' && filters.includes('optometrias')) {
      return true;
    } if (e.tipoElemento === 'contactologia' && filters.includes('contactologias')) {
      return true;
    }
    return false;
  }).slice(0, limit).map((e:any) => {
    if (e.tipoElemento === 'encargo') {
      return <Encargo data={e} menuAdvise={menuAdvise} deviceMobile={deviceMobile} setModalAdvise={setModalAdvise} />;
    } if (e.tipoElemento === 'optometria') {
      return <Optometria data={e} />;
    } if (e.tipoElemento === 'contactologia') {
      return <Contactologia data={e} />;
    }
  });
  const emptyActivity = successActivity && !loadingActivity && (!activity || activity.length === 0);
  const limiteMayorQueAElementos = limit > activity.length;
  // @ts-ignore
  const activityList: ReactElement = (
    <>
      <ModalAdvise pacienteSelected={pacienteSelected} closeModal={closeModal} modalState={modalAdvise} type={adviseType} />
      <div className="activityBody patient-activity">
        <div className="emptyBody">
          {/* <div className="empty">
              <img
                className="emptyIcon"
                src="img/pacientes/EmptyState.svg"
                alt="EmptyState"
              />
              <div className="emptyText">
                <p>Aun no hay datos.</p>
                &nbsp;
                <p className="createLink" onClick={openModal}>
                  Crear nueva prueba ahora
                </p>
              </div>
            </div> */}
        </div>
        <div className="filterBox">
          <span>{intl.formatMessage({ id: 'pacientes.activity.filter_by' })}</span>
          <div className="flexRow filterBar" style={{justifyContent: "space-between"}}>
            <div>
            <CheckableTag
              checked={filters.includes('encargos')}
              onChange={() => toggleFilter('encargos')}
            >
              {intl.formatMessage({ id: 'pacientes.activity.orders' })}
            </CheckableTag>
            {false
            && (
            <CheckableTag
              checked={filters.includes('presupuestos')}
              onChange={() => toggleFilter('presupuestos')}
            >
              {intl.formatMessage({ id: 'pacientes.activity.estimate' })}
            </CheckableTag>
            )
            }
            <CheckableTag
              checked={filters.includes('optometrias')}
              onChange={() => toggleFilter('optometrias')}
            >
              {intl.formatMessage({ id: 'pacientes.activity.optometries' })}
            </CheckableTag>
            <CheckableTag
              checked={filters.includes('contactologias')}
              onChange={() => toggleFilter('contactologias')}
            >
              {intl.formatMessage({ id: 'pacientes.activity.contactologies' })}
            </CheckableTag>
            {false

            && (
            <CheckableTag
              checked={filters.includes('audio')}
              onChange={() => toggleFilter('audio')}
            >
              {intl.formatMessage({ id: 'pacientes.activity.audio' })}
            </CheckableTag>
            )
            }
            {false
              && (
              <CheckableTag
                checked={filters.includes('avisos')}
                onChange={() => toggleFilter('avisos')}
              >
                {intl.formatMessage({ id: 'pacientes.activity.advises' })}
              </CheckableTag>
              )
            }
            </div>
            <div style={{paddingTop: ".5em"}}>
              <Button type="primary" shape="circle" icon="reload" onClick={() => {
                  sessionStorage.removeItem('infoPacienteActivityData');
                  history.push(generatePath(ROUTE_PACIENTES_FILE, { pacienteId: pacienteSelected.id }));
                }}/>
            </div>
          </div>
        </div>
        {!emptyActivity
          && (
          <InfiniteScroll
            scrollableTarget="scrollableDiv"
            dataLength={activityComponents.length} // This is important field to render the next data
            next={() => { setLimit(limit * 2); }}
            hasMore={loadingActivity || !limiteMayorQueAElementos}
            loader={<Flex my="16px" justifyContent="center"><Spin /></Flex>}
            endMessage={null}
          // below props only if you need pull down functionality
            refreshFunction={() => {}}
            pullDownToRefresh
            pullDownToRefreshThreshold={2}
            pullDownToRefreshContent={null}
            releaseToRefreshContent={null}
          >
            {loadingActivity ? null : activityComponents}
          </InfiniteScroll>
          )
        }
        {emptyActivity
          && (
          <Flex my="24px" justifyContent="center">
            <Empty
              description={(
                <span>
                  {intl.formatMessage({ id: 'pacientes.activity.empty' })}
                </span>
                )}
            />
          </Flex>
          )
        }
      </div>
    </>
  );
  return (
    activityList
  );
}

export default injectIntl(Activity);
